import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import ContactForm from "../components/ContactForm";
import EventHero from "../components/EventHero";

import "../styles/services-pages.css";

const eventServices = [
  {
    id: "01",
    title: { en: "Exhibitions & Conferences Management", ar: "إدارة المعارض والمؤتمرات" },
    points: {
      en: [
        "Event master planning",
        "Budget & financial feasibility",
        "Risk & safety management",
        "Registration & attendance (QR/RFID)",
        "VIP protocol",
        "On-ground operations & venue management",
        "Speakers & volunteers management",
        "Halls & interactive zones setup",
        "AV systems (sound/lighting/screens)",
        "Live streaming + post-event reports",
      ],
      ar: [
        "التخطيط العام للفعالية (Master Plan)",
        "الميزانية ودراسة الجدوى المالية",
        "إدارة المخاطر والسلامة",
        "التسجيل والحضور (QR/RFID)",
        "بروتوكول كبار الشخصيات (VIP)",
        "التشغيل الميداني وإدارة الموقع",
        "إدارة المتحدثين والمتطوعين",
        "تجهيز القاعات والمناطق التفاعلية",
        "أنظمة الصوت والإضاءة والشاشات",
        "البث المباشر + تقارير ما بعد الحدث",
      ],
    },
  },
  {
    id: "02",
    title: { en: "Exhibition & Booth Design", ar: "تصميم المعارض والأجنحة" },
    points: {
      en: [
        "Custom & modular booth design",
        "Build & decoration execution",
        "Printing & visual production",
        "Furniture & equipment rental",
        "Stages & interactive areas design",
      ],
      ar: [
        "تصميم أجنحة خاصة أو معيارية",
        "تنفيذ البناء والديكور",
        "الطباعة والإنتاج المرئي",
        "تأجير الأثاث والمعدات",
        "تصميم المسارح والمناطق التفاعلية",
      ],
    },
  },
  {
    id: "03",
    title: { en: "Strategic Marketing Services", ar: "خدمات التسويق الاستراتيجي" },
    points: {
      en: [
        "Full marketing strategy",
        "Market & competitor analysis",
        "Annual marketing plans",
        "Campaign identity development",
        "Messaging & content writing",
      ],
      ar: [
        "إعداد استراتيجية تسويق شاملة",
        "تحليل السوق والمنافسين",
        "خطط تسويق سنوية",
        "تطوير هوية الحملات",
        "صياغة الرسائل وكتابة المحتوى",
      ],
    },
  },
  {
    id: "04",
    title: { en: "Marketing & Digital Campaigns", ar: "الحملات التسويقية والرقمية" },
    points: {
      en: [
        "Google / Meta / LinkedIn campaigns",
        "Influencer marketing",
        "Traditional campaigns (OOH/TV/Press)",
        "Ad budget management & optimization",
        "Social media account management",
        "Creative content (design/video/motion)",
      ],
      ar: [
        "حملات Google / Meta / LinkedIn",
        "تسويق المؤثرين",
        "حملات تقليدية (لوحات/تلفزيون/صحافة)",
        "إدارة ميزانية الإعلانات وتحسين الأداء",
        "إدارة حسابات التواصل الاجتماعي",
        "محتوى إبداعي (تصميم/فيديو/موشن)",
      ],
    },
  },
  {
    id: "05",
    title: { en: "Public Relations & Media Relations", ar: "العلاقات العامة والإعلامية" },
    points: {
      en: [
        "Press releases & media content",
        "Media outreach (press/channels)",
        "Press conferences management",
        "Official spokesperson appearances",
        "Media coverage reports",
      ],
      ar: [
        "بيانات صحفية ومحتوى إعلامي",
        "التواصل مع وسائل الإعلام (صحف/قنوات)",
        "إدارة المؤتمرات الصحفية",
        "ظهور المتحدث الرسمي",
        "تقارير التغطية الإعلامية",
      ],
    },
  },
  {
    id: "06",
    title: { en: "Event Marketing", ar: "تسويق الفعاليات" },
    points: {
      en: [
        "Attract exhibitors",
        "Attract visitors & audience",
        "Event platforms (website/app)",
        "Event content planning & management",
      ],
      ar: [
        "استقطاب العارضين",
        "استقطاب الزوار والجمهور",
        "منصات الفعالية (موقع/تطبيق)",
        "تخطيط محتوى الفعالية وإدارته",
      ],
    },
  },
  {
    id: "07",
    title: { en: "Sponsorship & Partnerships", ar: "الرعايات والشراكات" },
    points: {
      en: [
        "Sponsorship packages design",
        "Sponsor sourcing & outreach",
        "Pitch decks preparation",
        "Contracts & deliverables management",
      ],
      ar: [
        "تصميم باقات الرعاية",
        "استقطاب الرعاة والتواصل معهم",
        "إعداد عروض تقديمية (Pitch Deck)",
        "إدارة العقود والمخرجات",
      ],
    },
  },
  {
    id: "08",
    title: { en: "Logistics & Hospitality", ar: "الخدمات اللوجستية والضيافة" },
    points: {
      en: [
        "Hotels & flights booking",
        "Guests transport & mobility",
        "Hospitality & catering",
        "Gifts & media giveaways",
      ],
      ar: [
        "حجز الفنادق والرحلات",
        "تنقلات الضيوف والمواصلات",
        "الضيافة والتموين (Catering)",
        "الهدايا والتوزيعات الدعائية",
      ],
    },
  },
  {
    id: "09",
    title: { en: "Media Production Services", ar: "خدمات إنتاج الوسائط" },
    points: {
      en: [
        "Event video production & commercials",
        "Motion graphics 2D/3D",
        "Multi-camera live streaming",
        "Photography (events/VIP/products)",
        "Editing, VFX, short content (Reels/Shorts)",
      ],
      ar: [
        "إنتاج فيديوهات الفعاليات والإعلانات",
        "موشن جرافيك 2D/3D",
        "بث مباشر متعدد الكاميرات",
        "تصوير (فعاليات/كبار شخصيات/منتجات)",
        "مونتاج ومؤثرات ومحتوى قصير (Reels/Shorts)",
      ],
    },
  },
  {
    id: "10",
    title: { en: "Podcast Production Services", ar: "خدمات إنتاج البودكاست" },
    points: {
      en: [
        "Concept & identity development",
        "Scripts writing",
        "Audio / Video podcast recording",
        "Studio & equipment availability",
        "Audio editing & sound branding",
        "Publishing (YouTube/Spotify/Apple)",
        "Event & corporate podcasts",
      ],
      ar: [
        "تطوير الفكرة والهوية",
        "كتابة السكربت",
        "تسجيل بودكاست صوتي/مرئي",
        "توفير الاستوديو والمعدات",
        "تحرير الصوت وبصمة صوتية (Sound Branding)",
        "النشر (YouTube/Spotify/Apple)",
        "بودكاست للفعاليات والشركات",
      ],
    },
  },
];

function EventMarketingPage() {
  const [language, setLanguage] = useState("en");
  const [isScrolled, setIsScrolled] = useState(false);

  // Load saved language
  useEffect(() => {
    const saved = localStorage.getItem("lang");
    if (saved === "en" || saved === "ar") setLanguage(saved);
  }, []);

  // Save language on change
  useEffect(() => {
    localStorage.setItem("lang", language);
  }, [language]);

  // Header scroll effect
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleLanguage = () =>
    setLanguage((prev) => (prev === "en" ? "ar" : "en"));

  return (
    <div className="app" lang={language} dir="ltr">
      <Header
        language={language}
        toggleLanguage={toggleLanguage}
        isScrolled={isScrolled}
      />
 <EventHero language={language} />

      <section className="service-detail-section">
        <h2 className="detail-title">
          {language === "en"
            ? "Integrated Event, Marketing & Media Services"
            : "خدمات الفعاليات والتسويق والإعلام المتكاملة"}
        </h2>

        <p className="detail-desc">
          {language === "en"
            ? "A complete suite of solutions for exhibitions, conferences, strategic marketing and media production."
            : "مجموعة كاملة من الحلول للمعارض والمؤتمرات والتسويق الاستراتيجي وإنتاج الإعلام."}
        </p>

        <div className="detail-grid">
          {eventServices.map((service) => (
            <div key={service.id} className="detail-card">
              <div className="detail-icon">{service.id}</div>
              <h3>{service.title[language]}</h3>
              <ul>
                {service.points[language].map((p, idx) => (
                  <li key={`${service.id}-${idx}`}>{p}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>

      <ContactForm language={language} />
    </div>
  );
}

export default EventMarketingPage;